import { useQuery as useProductPromotionsQuery, useInvalidateQuery as useInvalidatePromotionsQuery } from "@faire/web-api--source/api/product/productToken/product-promo-messages/get-hooks";
import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";
import { useMemo } from "react";
export var useProductPromotionsState = function(productToken, fetchProductPromotions) {
    var invalidatePromotionsQuery = useInvalidatePromotionsQuery();
    var _useProductPromotionsQuery = useProductPromotionsQuery(productToken !== null && productToken !== void 0 ? productToken : "", {
        refetchOnMount: false,
        enabled: !!productToken && fetchProductPromotions
    }), productPromotions = _useProductPromotionsQuery.data;
    var nonFashionWeekPromos = useMemo(function() {
        var _productPromotions_promo_messages;
        return productPromotions === null || productPromotions === void 0 ? void 0 : (_productPromotions_promo_messages = productPromotions.promo_messages) === null || _productPromotions_promo_messages === void 0 ? void 0 : _productPromotions_promo_messages.filter(function(promotion) {
            return promotion.type !== IInformationMessage.Type.FAIRE_FUNDED_PROMO_BANNER;
        });
    }, [
        productPromotions
    ]);
    var marketPromo = useMemo(function() {
        var _productPromotions_promo_messages;
        return productPromotions === null || productPromotions === void 0 ? void 0 : (_productPromotions_promo_messages = productPromotions.promo_messages) === null || _productPromotions_promo_messages === void 0 ? void 0 : _productPromotions_promo_messages.find(function(promotion) {
            return promotion.type === IInformationMessage.Type.MARKET_PROMO;
        });
    }, [
        productPromotions
    ]);
    var promotionStyleBanners = useMemo(function() {
        return nonFashionWeekPromos === null || nonFashionWeekPromos === void 0 ? void 0 : nonFashionWeekPromos.filter(function(promotion) {
            return promotion.style === IInformationMessage.Style.PROMO;
        });
    }, [
        nonFashionWeekPromos
    ]);
    var nonPromotionStyleBanners = useMemo(function() {
        return nonFashionWeekPromos === null || nonFashionWeekPromos === void 0 ? void 0 : nonFashionWeekPromos.filter(function(promotion) {
            return promotion.style !== IInformationMessage.Style.PROMO;
        });
    }, [
        nonFashionWeekPromos
    ]);
    var guaranteedFreeShippingPromo = useMemo(function() {
        var _productPromotions_promo_messages;
        return productPromotions === null || productPromotions === void 0 ? void 0 : (_productPromotions_promo_messages = productPromotions.promo_messages) === null || _productPromotions_promo_messages === void 0 ? void 0 : _productPromotions_promo_messages.find(function(promotion) {
            return promotion.type === IInformationMessage.Type.GUARANTEED_FREE_SHIPPING_THRESHOLD;
        });
    }, [
        productPromotions
    ]);
    return useMemo(function() {
        var _productPromotions_promo_messages;
        return {
            productPromotions: (_productPromotions_promo_messages = productPromotions === null || productPromotions === void 0 ? void 0 : productPromotions.promo_messages) !== null && _productPromotions_promo_messages !== void 0 ? _productPromotions_promo_messages : [],
            insiderLabel: productPromotions === null || productPromotions === void 0 ? void 0 : productPromotions.insider_label,
            promotionLabel: productPromotions === null || productPromotions === void 0 ? void 0 : productPromotions.promo_label,
            nonFashionWeekPromos: nonFashionWeekPromos !== null && nonFashionWeekPromos !== void 0 ? nonFashionWeekPromos : [],
            marketPromo: marketPromo,
            promotionStyleBanners: promotionStyleBanners !== null && promotionStyleBanners !== void 0 ? promotionStyleBanners : [],
            nonPromotionStyleBanners: nonPromotionStyleBanners !== null && nonPromotionStyleBanners !== void 0 ? nonPromotionStyleBanners : [],
            guaranteedFreeShippingPromo: guaranteedFreeShippingPromo,
            productToken: productToken,
            invalidatePromotionsQuery: invalidatePromotionsQuery
        };
    }, [
        productPromotions,
        nonFashionWeekPromos,
        marketPromo,
        promotionStyleBanners,
        nonPromotionStyleBanners,
        guaranteedFreeShippingPromo,
        productToken,
        invalidatePromotionsQuery
    ]);
};
